import styled from 'styled-components'

import { theme } from 'styles/theme'

import { fluidType } from '../fluid-type'

const { colors, lineHeights, media, radii, space } = theme

export { Section } from 'components/general-styles/General'

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['spacing-xl']};

  h2 {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    line-height: ${lineHeights['font-line-height-sm']};
    letter-spacing: -0.02em;
  }
`

export const PolygonWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
`

export const Lead = styled.div`
  margin-top: ${space['spacing-xl']};

  p {
    margin: 0;
  }
`

/* Mesmo eco sólido do painel de denúncias, aqui com borda ciano. */
export const Panel = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-xl']};
  margin-top: ${space['spacing-xl']};
  padding: ${space['spacing-lg']} ${space['spacing-md']};
  background-color: ${colors['neutral-background-contrast']};
  border: 1px solid ${colors['cyan-background-pressed']};

  /* 20px do desenho: a escala de raio pula de 16px para 24px. */
  border-radius: 1.25rem;
  box-shadow: 10px 10px 0 0 ${colors['blue-background-strong-default']};

  @media (${media.desktop}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 3.125rem;
    padding: ${space['spacing-xl']};
  }
`

export const Pillar = styled.div<{ $wide?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-lg']};

  p {
    margin: 0;
  }

  @media (${media.desktop}) {
    grid-column: ${({ $wide }) => ($wide ? '1 / span 2' : 'auto')};
  }
`

export const PillarHeader = styled.header`
  display: flex;
  align-items: center;
  gap: ${space['spacing-lg']};
`

/* Azul mais fechado que o fundo do painel, para a caixa do ícone destacar.
   Nenhum token carrega esse valor. */
export const IconWrapper = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${space['spacing-xxs']};

  /* Transparente, para a caixa ficar da cor do card. Era o valor fixo
     #131c2e, mais escuro que o #00284B do card, e aparecia como um fundo
     preto atrás de cada ícone. Transparente em vez de repetir a cor do card:
     acompanha se ela mudar. */
  background-color: transparent;
  border: 1px solid ${colors['cyan-background-pressed']};
  border-radius: ${radii['corner-radius-sm']};

  img {
    width: ${space['spacing-md']};
    height: ${space['spacing-md']};
  }
`

export const PillarBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};
`

export const Link = styled.a`
  color: ${colors['cyan-background-pressed']};
  text-decoration: underline;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }
`

export const Emphasis = styled.span`
  color: ${colors['cyan-background-pressed']};
`
